import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoader } from "../../../utils/LoaderContext";
import RtoStatus from "./RtoStatus";
import AcceeptRto from "./RtoStatus/AcceptRto";
import RejectRto from "./RtoStatus/RejectRto";

const RtoReturns = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [activeTab, setActiveTab] = useState("rtodelivered");
  const { setLoading } = useLoader();
  const location = useLocation();
  

  // ✅ Add 3 tabs now
  const tabList = [
    { key: "rtodelivered", label: "RTO Delivered", color: "bg-primary" },
    { key: "accepted", label: "Accepted RTO", color: "bg-primary" },
    { key: "rejected", label: "Rejected RTO", color: "bg-primary" },
  ];

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timeout);
  }, [activeTab, setLoading]);

  useEffect(() => {
    const tabFromURL = new URLSearchParams(location.search).get("tab");
    if (tabFromURL) {
      setActiveTab(tabFromURL);
    } else {
      navigate("?tab=rtodelivered", { replace: true });
    }
  }, [location.search, navigate]);

  const renderTable = () => {
    switch (activeTab) {
      case "rtodelivered":
        return <RtoStatus status="rtodelivered" searchText={searchText} />;
      case "accepted":
        return <AcceeptRto status="accepted" searchText={searchText} />;
      case "rejected":
        return <RejectRto status="rejected" searchText={searchText} />;
      default:
        return (
          <div className="text-center py-8 text-gray-500">
            Select a tab to view orders
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">
      {/* Sticky Header */}
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="w-full bg-white border-t">
          <div className="px-4 py-3">
            <div className="flex gap-2 overflow-x-auto hide-scrollbar scroll-smooth">
              {tabList.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => navigate(`?tab=${tab.key}`)}
                  className={`px-4 py-1 text-sm rounded border transition-all duration-200 whitespace-nowrap
                    ${
                      activeTab === tab.key
                        ? `${tab.color} text-white ring-2 ring-offset-1 ring-white`
                        : "text-primary bg-primaryLight hover:bg-primary hover:text-white border-primary"
                    }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-gray-50 overflow-hidden">
        <div className="h-full p-4 overflow-auto">
          <div className="max-w-full">{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default RtoReturns;
